const Hotspot = {
  parts: [
    'hotspot',
    'hotspotIcon'
  ],
  baseStyle: {
    hotspot: {
      position: 'absolute',
      width: {base: '16px', md: '24px'},
      height: {base: '16px', md: '24px'},
      border: '1.2px solid white',
      borderRadius: 'full',
      filter: 'drop-shadow(0 0 30px rgba(0, 0, 0, 0.10))',
      cursor: 'pointer',
      color: 'white',
      zIndex: 1,
      _hover: {
        borderColor: 'brandColors.greyscale',
        backgroundColor: 'brandColors.greyscale',
        boxShadow: '0 0 0 4px rgba(255, 255, 255, 0.40)',
      },
      transition: 'all 0.2s ease',
    },
    hotspotIcon: {
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      width: {base: '8px', md: '12px'},
      height: {base: '8px', md: '12px'},
      sx: {
        ' svg': {
          position: 'absolute',
          width: {base: '8px', md: '12px'},
          height: {base: '8px', md: '12px'},
        },
      },
    },
  },
};

export default Hotspot;
